/**
 * Shared formatting helpers for exposed value dashboards.
 */
export const formatValue = (value: number | string | null | undefined) => {
  if (value === null || value === undefined) return "--";
  if (typeof value === "number") return value.toFixed(2);
  return String(value);
};
